import React, { useContext } from 'react'

import { FnaContext } from '../../../context'
import { ConfirmationDialog } from '../../../../../components/Dialog'
import { Button } from '../../../../../components/Button'
import { ASSESSMENT_TYPE } from '../../../reducer'


export const Destroy = () => {
  const {
    state: { loading },
    actions: { goBack, deleteAssessment }
  } = useContext(FnaContext)

  const trackingText = 'Income protection: Confirm delete'
  return (
    <ConfirmationDialog
      heading='Are you sure you want to delete your income protection assessment?'
      primaryButton={() => 
        <Button
          disabled={loading}
          primary trackAs={trackingText} onClick={deleteAssessment(ASSESSMENT_TYPE.INCOME_PROTECTION)}
        >
          {loading ? 'Deleting assessment...' : "YES I'M SURE"}
        </Button>}
      secondaryButton={() => <Button disabled={loading} secondary onClick={goBack}>NOT RIGHT NOW</Button>}
    />
  )
}
